var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dv-border-box-11',{attrs:{"title":"生产过程","color":['rgba(124, 231, 253, 1)', 'rgba(46, 96, 153, 1)']}},[_c('div',{staticStyle:{"padding":"80px 0 10px","height":"100%"}},[_c('dv-scroll-board',{attrs:{"config":_vm.config}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }